import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {ServiceWorkerModule} from '@angular/service-worker';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ToastModule} from 'ng2-toastr/ng2-toastr';
import {FormsModule} from '@angular/forms';
import {environment} from '../environments/environment';
import {SharedModule} from '@Shared/shared-module/shared.module';
import {Globals} from './globals';
import {OverlayService} from '@myServices/overlay.service';
import {ModalService} from '@myServices/modal.service';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpClient} from '@angular/common/http';
import {AuthenticationService} from '@Shared/services';
import {TransactionService} from '@myServices/transaction.service';
import {DecimalPipe} from '@angular/common';
import {AuthGuard} from '@myServices/auth-guard';
import { Ng2OdometerModule } from 'ng2-odometer';
import {GlobalLoaderService} from "@myServices/global-loader.service";


export function HttpLoaderFactory(httpClient: HttpClient) {
    return new TranslateHttpLoader(httpClient, '/assets/i18n/', '.json');
}

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        SharedModule,
        FormsModule,
        ToastModule.forRoot(),
        BrowserAnimationsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        ServiceWorkerModule.register('/ngsw-worker.js', {
            enabled: environment.production
        }),
        Ng2OdometerModule.forRoot()
    ],
    providers: [
        Globals,
        OverlayService,
        ModalService,
        AuthenticationService,
        TransactionService,
        DecimalPipe,
        AuthGuard,
        GlobalLoaderService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/app.module.ts